export const moneyFormatter = (value: number | string): string => {
  if (typeof value === 'string') {
    return moneyFormatter(parseFloat(value));
  } else {
    const intl = new Intl.NumberFormat('en').format(Math.round(value));
    return "£" + intl;
  }
};